<div class="fh-button" [ngClass]="outerClass">
  <p-button
    [type]="chosenType"
    [label]="(locked ? label + ' ( '+ timeLeft +' )' : label)"
    [severity]="severity"
    [outlined]="outline"
    [styleClass]="computedClass"
    [loading]="loading"
    [size]="size"
    [disabled]="loading || disabled || locked"
    [icon]="icon"
    [iconPos]="iconPos"
    [badge]="badge"
    [badgeClass]="badgeClass"
    (click)="onClick()"
    [pTooltip]="tooltip"
    appendTo="body"
    [tooltipPosition]="tooltipPosition"
    [ariaLabel]="label || tooltip" />
</div>
